/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputWindLabSegment } from './OutputWindLabSegment';
import {
    OutputWindLabSegmentFromJSON,
    OutputWindLabSegmentFromJSONTyped,
    OutputWindLabSegmentToJSON,
} from './OutputWindLabSegment';

/**
 * 
 * @export
 * @interface OutputWindLabResult
 */
export interface OutputWindLabResult {
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabResult
     */
    airspeedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabResult
     */
    altitudeM?: number;
    /**
     * DeltaSeconds — наскільки довше(+)/швидше(-) політ через вітер проти безвітряного.
     * @type {number}
     * @memberof OutputWindLabResult
     */
    deltaSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabResult
     */
    effectiveGroundSpeedMs?: number;
    /**
     * SampledSegments — скільки сегментів мали дані вітру (решта пораховані як безвітряні).
     * @type {number}
     * @memberof OutputWindLabResult
     */
    sampledSegments?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabResult
     */
    secondsNoWind?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabResult
     */
    secondsWind?: number;
    /**
     * 
     * @type {Array<OutputWindLabSegment>}
     * @memberof OutputWindLabResult
     */
    segments?: Array<OutputWindLabSegment>;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabResult
     */
    totalLenM?: number;
    /**
     * WindValidTime — час зрізу вітру (RFC3339); порожньо, якщо даних вітру нема зовсім.
     * @type {string}
     * @memberof OutputWindLabResult
     */
    windValidTime?: string;
}

/**
 * Check if a given object implements the OutputWindLabResult interface.
 */
export function instanceOfOutputWindLabResult(value: object): boolean {
    return true;
}

export function OutputWindLabResultFromJSON(json: any): OutputWindLabResult {
    return OutputWindLabResultFromJSONTyped(json, false);
}

export function OutputWindLabResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWindLabResult {
    if (json == null) {
        return json;
    }
    return {
        
        'airspeedMs': json['airspeedMs'] == null ? undefined : json['airspeedMs'],
        'altitudeM': json['altitudeM'] == null ? undefined : json['altitudeM'],
        'deltaSeconds': json['deltaSeconds'] == null ? undefined : json['deltaSeconds'],
        'effectiveGroundSpeedMs': json['effectiveGroundSpeedMs'] == null ? undefined : json['effectiveGroundSpeedMs'],
        'sampledSegments': json['sampledSegments'] == null ? undefined : json['sampledSegments'],
        'secondsNoWind': json['secondsNoWind'] == null ? undefined : json['secondsNoWind'],
        'secondsWind': json['secondsWind'] == null ? undefined : json['secondsWind'],
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(OutputWindLabSegmentFromJSON)),
        'totalLenM': json['totalLenM'] == null ? undefined : json['totalLenM'],
        'windValidTime': json['windValidTime'] == null ? undefined : json['windValidTime'],
    };
}

export function OutputWindLabResultToJSON(value?: OutputWindLabResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'airspeedMs': value['airspeedMs'],
        'altitudeM': value['altitudeM'],
        'deltaSeconds': value['deltaSeconds'],
        'effectiveGroundSpeedMs': value['effectiveGroundSpeedMs'],
        'sampledSegments': value['sampledSegments'],
        'secondsNoWind': value['secondsNoWind'],
        'secondsWind': value['secondsWind'],
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(OutputWindLabSegmentToJSON)),
        'totalLenM': value['totalLenM'],
        'windValidTime': value['windValidTime'],
    };
}

